import { render } from "./IsoVoyageMalysia.vue?vue&type=template&id=0e1c91e9"
import script from "./IsoVoyageMalysia.vue?vue&type=script&lang=js"
export * from "./IsoVoyageMalysia.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__